import { HTTP } from '@/services/axios';

export async function getDocuments({filterText,filterLibrary,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/Document/getDocumentList.php',{
        params:{
            filterText,
            filterLibrary,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getDocument({documentId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Document/getDocumentData.php?documentId=${documentId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}

export async function getDocumentPreview({documentId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Document/getDocumentPreview.php?documentId=${documentId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getDocumentsByLibrary({libraryId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Document/getDocumentsByLibrary.php?libraryId=${libraryId}`
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function unlockDocument({documentId}){
    let result = {};

    var data = {'myRecordID':documentId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Document/controlDocumentUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStateDocument({recordId,state}){
    let result = {};

    var data = {'recordId':recordId,'state':state}
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Document/controlDocumentChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function createDocument({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/Document/controlDocumentSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveDocument({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/Document/controlDocumentSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteDocument({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/Document/controlDocumentDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

//upload document
export async function getDataToUpload(){
    let result = {};
 
    await HTTP({
        method: 'get',
        url: '/app/core/Document/docsUpload/getLibraryUploadData.php'
    })
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export function uploadDocUrl(){
    return "/app/core/Document/docsUpload/controlDocumentUpload.php";
}